// extracted by mini-css-extract-plugin
export default {"secondary":"viewBlogger_secondary__k4Ojo","primary":"viewBlogger_primary__GCbnx","conditions":"viewBlogger_conditions__D5UvN"};